var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.164 0H2.16405C1.78516 0 1.4218 0.15051 1.15389 0.418419C0.885984 0.686328 0.735474 1.04969 0.735474 1.42857V18.5714C0.735474 18.9503 0.885984 19.3137 1.15389 19.5816C1.4218 19.8495 1.78516 20 2.16405 20H12.164C12.5429 20 12.9063 19.8495 13.1742 19.5816C13.4421 19.3137 13.5926 18.9503 13.5926 18.5714V1.42857C13.5926 1.04969 13.4421 0.686328 13.1742 0.418419C12.9063 0.15051 12.5429 0 12.164 0ZM7.87833 18.5714H6.44976V17.1429H7.87833V18.5714ZM2.16405 15.7143V1.42857H12.164V15.7143H2.16405Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.fda2446989221a4d924e35627c61db48.svg";
export { ForwardRef as ReactComponent };